import React, { useEffect, useState } from "react";
import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";
import axiosInstance from "../../../utils/axiosConfig";
import { API_URL } from "../../../constant";
import { useAuth } from "../../../context/auth-context";
import { TailSpin } from "react-loader-spinner";

const SummaryPie = () => {
  const { isAuthenticated } = useAuth();
  const [summaryLoader, setSummaryLoader] = useState<boolean>(false);
  const [summary, setSummary] = useState<any>({});

  useEffect(() => {
    if (!summaryLoader) {
      setSummaryLoader(true);
      axiosInstance
        .get(`${API_URL}api/users/survey/summary`)
        .then((r: any) => {
          setSummary(r?.data?.data?.primaryUseSummary);
          setSummaryLoader(false);
        })
        .catch((e: any) => {
          console.log(e.response.data.message);
          setSummaryLoader(false);
        });
    }
  }, [isAuthenticated]);

  const chartData = {
    series: [
      summary?.crypto || 0,
      summary?.giftcard || 0,
      summary?.bills || 0,
      summary?.all || 0,
    ],
    options: {
      chart: {
        type: "donut",
      },
      labels: ["Trade Crypto", "Trade Gift Cards", "Bills", "All"],
      colors: ["#30363B", "#2C3A44", "#095B97", "#0B75C2"],
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                color: "#ffffff",
                fontSize: "20px",
                fontFamily: "Sora, sans-serif",
                fontWeight: 700,
              },
              value: {
                show: true,
                color: "#BEE1FB",
                formatter: (val: string) => `$${val}`,
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "right",
              markers: {
                fillColors: ["#30363B", "#35434E", "#095B97", "#0B75C2"],
              },
            },
          },
        },
      ],
      legend: {
        position: "right",
        markers: {
          fillColors: ["#30363B", "#35434E", "#095B97", "#0B75C2"],
        },
        fontSize: "12px",
        fontFamily: "Manrope, sans-serif",
        fontWeight: 500,
        labels: {
          colors: "#ffffff",
          useSeriesColors: false,
        },
      },
    } as ApexOptions,
  };

  return (
    <div className="w-full">
      {summaryLoader ? (
        <div className="w-full flex justify-center items-center mt-6">
          <TailSpin color="#0B75C2" height={60} width={50} />
        </div>
      ) : (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={300}
        />
      )}
    </div>
  );
};

export default SummaryPie;
